import Icon from "~/components/shared/Icon";

export function totalAnnotationCount(countsByStyle: Record<string, number>): number {
  return Object.values(countsByStyle).reduce((sum, val) => sum + val, 0);
}

export function AnnotationsBadge({
  countsByStyle,
  className,
}: {
  countsByStyle: Record<string, number>;
  className?: string;
}) {
  const total = totalAnnotationCount(countsByStyle);

  if (total === 0) {
    return null;
  }

  const label = total === 1 ? "1 annotation" : `${total} annotations`;

  return (
    <span
      data-annotations-badge={true}
      title={label}
      className={`inline-flex items-center rounded-full bg-white p-1 ring-1 ring-gray-700 ${className || ""}`}
    >
      <Icon icon="sticky-note" style={{ fill: "none" }} className="text-charcoal-700 h-3 w-3" />
    </span>
  );
}
